module.exports = __webpack_public_path__ + "img/addHouse.8d493565.png";